import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const APP_LOADED_SCHEMA = Object.freeze({
  CARD_FORM_EMPTY: false,
  CARD_FORM_COMPLETED: false,
  CARD_FORM_VALIDATION_ERROR: '',
});
const RECORD = generateSchema(APP_LOADED_SCHEMA);
const KEYS: any = generateKeys(APP_LOADED_SCHEMA);

export class CardFormChangedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.card_form_changed;
  }

  get properties() {
    return this.toJS();
  }
}
